// src/components/TwoFactorAuthPage.js
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { Backdrop, Box, ButtonBase, CircularProgress, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';
import Swal from 'sweetalert2';

import { AuthContext } from '../../contexts/auth';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const HOST = process.env.REACT_APP_HOST;

const passwordRequirements = [
  { label: 'Pelo menos 8 caracteres', isValid: (password) => password.length >= 8 },
  { label: 'Pelo menos 1 letra maiúscula', isValid: (password) => /[A-Z]/.test(password) },
  { label: 'Pelo menos 1 letra minúscula', isValid: (password) => /[a-z]/.test(password) },
  { label: 'Pelo menos 1 número', isValid: (password) => /\d/.test(password) },
  { label: 'Pelo menos 1 caractere especial', isValid: (password) => /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/.test(password) }
];

const PassTwoFactorAuthPage = () => {
  const { login, logout, loading, toggleLoading, setAuth } = React.useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);
  const [password1, setPassword1] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {

    toggleLoading(true);

    try {
      fetch(`${HOST}/api/authenticate/resetpass`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cnpj: localStorage.getItem('cnpj'),
          senha: password,
          carteira: localStorage.getItem('carteira'),
          cpf: localStorage.getItem('cpf')
        }),
      })
        .then(
          (res) => res.json()
        )
        .then(async(data) => {
          toggleLoading(false);
          if (data.exec === 'OK') {
            if(data.user.cnpj) localStorage.setItem('cnpj', data.user.cnpj);
            if(data.user.cpf) localStorage.setItem('cpf', data.user.cpf);
            
            await Swal.fire({
              icon: 'success',
              title: 'Senha alterada com sucesso!',
              confirmButtonText: 'OK'
            });
            
            // if (data.user.role === "contratante") {
            //   localStorage.setItem('user', data.user.cnpj)
            //   login(data.user.cnpj, data.user.role, data.token);//Remover apos voltar 2fa
            // } else {
            //   localStorage.setItem('user', data.user.cpf)
            //   login(data.user.cpf, data.user.role, data.token);//Remover apos voltar 2fa
              
            // } Descomentar apos voltar 2fa

            setAuth(false); 
            
            // navigate('/2fa');
            navigate('/login');//Remover apos voltar 2fa
            
          }
          else {
            console.log(data.user.exec)
            alert('Erro!');
          }
        });
    } catch (err) {
      toggleLoading(false);
      setAuth(false);
      alert(errorMessage);
    }
  };

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleTogglePassword1 = () => {
    setShowPassword1((prevShowPassword) => !prevShowPassword);
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
  };

  const handlePassword1Change = (event) => {
    const newPassword = event.target.value;
    setPassword1(newPassword);
  };

  const comparePasswords = () => password === password1;

  const areAllFieldsFilled = () => password !== '' && password1 !== '' && comparePasswords();

  const isPasswordValid = () => passwordRequirements.every((requirement) => requirement.isValid(password)) && comparePasswords();

  return (
    <div className="two-factor-auth">
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" width="80%" margin="0 auto">
        <h2>ATUALIZAÇÃO DE SENHA</h2>
        <p style={{ textAlign: 'center' }}>
        </p>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel htmlFor="Nova">Nova Senha</InputLabel>
          <OutlinedInput
            id="Nova"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={handlePasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Nova Senha"
            inputProps={{ maxLength: 16 }}
          />
          <Grid container alignItems="flex-start" justifyContent="flex-start" mt={1}>
            <Typography variant="caption">Requisitos da senha:</Typography>
            {passwordRequirements.map((requirement, index) => (
              <Grid item xs={12} key={index}>
                <Typography
                  variant="caption"
                  color={requirement.isValid(password) ? 'textSecondary' : 'error'}
                  sx={{ display: 'block', marginLeft: '8px' }}
                >
                  {requirement.isValid(password) ? '✓' : '✗'} {requirement.label}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel htmlFor="Validacao">Repita a senha</InputLabel>
          <OutlinedInput
            id="Validacao"
            type={showPassword1 ? 'text' : 'password'}
            value={password1}
            onChange={handlePassword1Change}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword1} edge="end">
                  {showPassword1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Repita a senha"
            inputProps={{ maxLength: 16 }}
          />
        </FormControl>
        {!comparePasswords() && (
          <Typography variant="caption" color="error">
            As senhas não são as mesmas.
          </Typography>
        )}
        <ButtonBase
          disabled={!isPasswordValid() || !areAllFieldsFilled()}
          sx={{
            display: 'block',
            margin: '10px auto',
            backgroundColor: isPasswordValid() && areAllFieldsFilled() ? '#008b50' : 'grey',
            color: '#fafafa',
            padding: '10px 20px',
            borderRadius: '5px',
            '&:hover': {
              backgroundColor: isPasswordValid() && areAllFieldsFilled() ? '#009439' : 'grey',
              opacity: 1,
            },
          }}
          onClick={handleSubmit}
        >
          Atualizar Senha
        </ButtonBase>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </div>
  );
};

export default PassTwoFactorAuthPage;
